<template>
    <div class="employees_section">
        <i class="uis uis-user"></i>
        <h2>Employees</h2>
        <h2>This section is under construction</h2>
    </div>
</template>

<script>
export default {

}
</script>

<style>
.employees_section {
    padding-top: 2rem;

    i {
        font-size: 2rem;
    }
}
</style>